import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-designing',
  templateUrl: './designing.component.html',
  styleUrls: ['./designing.component.scss']
})
export class DesigningComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Designing/BIM');
  }

}
